export default __webpack_public_path__ + "static/media/whatsappLogo.e1f09d80.svg";